import React, { useState } from 'react';
import { Modal, Form, Radio, message, Typography, Divider } from 'antd';
import { adminTasksApi } from '../../../services/api/adminTasks';
import { AdminTaskType, AdminTaskStatus } from '../../../types';

const { Text } = Typography;

interface AutoProcessConfigModalProps {
  visible: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  storyId: string;
  chapterId: string;
  chapterName: string;
}

const AutoProcessConfigModal: React.FC<AutoProcessConfigModalProps> = ({
  visible,
  onCancel,
  onSuccess,
  storyId,
  chapterId,
  chapterName,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const detail = {
        input: {
          sourceStoryId: storyId,
          chapterId: chapterId,
          panelMediaType: values.panelMediaType,
          videoForm: values.videoForm,
        },
        progress: 0,
        process: {},
        targetId: storyId,
      };

      await adminTasksApi.createTask({
        type: AdminTaskType.AUTO_PROCESS,
        detail: detail as any,
      });

      message.success(`Đã khởi tạo tiến trình Auto Process cho chương "${chapterName}" thành công!`);
      onSuccess();
    } catch (error: any) {
      if (error?.errorFields) {
        return;
      }
      console.error('Failed to create auto process task:', error);
      message.error('Không thể khởi tạo tiến trình: ' + (error.message || 'Lỗi không xác định'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={<span>⚙️ Tự động xử lý Process - <b>{chapterName}</b></span>}
      open={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      confirmLoading={loading}
      width={500}
      okText="Bắt đầu"
      cancelText="Hủy"
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          panelMediaType: 'IMAGE',
          videoForm: 'SHORT',
        }}
      >
        <div style={{ marginBottom: '16px' }}>
          <Text type="secondary">
            Hệ thống sẽ tự động tạo Process mới từ chương này và thực hiện toàn bộ các bước xử lý visual pipeline.
          </Text>
        </div>

        <Divider orientation={"left" as any}>Cấu hình Media</Divider>

        <Form.Item
          name="videoForm"
          label="Định dạng Video"
          rules={[{ required: true, message: 'Vui lòng chọn định dạng video' }]}
        >
          <Radio.Group>
            <Radio value="SHORT">SHORT (9:16 — Dọc, TikTok/Shorts)</Radio>
            <Radio value="LONG">LONG (16:9 — Ngang, Desktop/Web)</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="panelMediaType"
          label="Loại Media ưu tiên cho Panel"
          rules={[{ required: true, message: 'Vui lòng chọn loại media' }]}
        >
          <Radio.Group>
            <Radio value="IMAGE">Chỉ dùng Ảnh (Nhanh)</Radio>
            <Radio value="VIDEO">Ưu tiên Video (Đẹp nhưng lâu)</Radio>
            <Radio value="MIX">Mix Ảnh & Video (Tự động)</Radio>
          </Radio.Group>
        </Form.Item>

        <Text type="secondary" style={{ fontSize: '12px' }}>
          * Lưu ý: Nếu chọn Video, thời gian xử lý sẽ phụ thuộc vào hàng đợi của AI Video Provider.
        </Text>
      </Form>
    </Modal>
  );
};

export default AutoProcessConfigModal;
